const SimpleLightBox = function() {

    const constlightBx = function () {

        const parentGal = $('.img-zoom');

        parentGal.each(function() {

            if($(this).find('.js-zoom').length > 0) {
                new SimpleLightbox($(this).find('.js-zoom'), { 
                    scrollZoom      : true,
                    overlayOpacity  : 1,
                    loop            : false,
                    docClose        : false,
                    uniqueImages    : true,
                    nav             : false,
                    rel             : false,
                    //showCounter : false
                });
            }

        });
        

    }

    return {
        init: function() {

            $(document).on('click', '.bt-zoom', function(e){
                e.preventDefault();
                // console.log('click');
            })
            constlightBx();
        
        }
    }

}()

module.exports = SimpleLightBox;